import React from 'react';

const TickAnimation = ({ color = '#00b437' }) => {
  return (
    <svg
      style={{ maxHeight: '500px' }}
      textRendering="geometricPrecision"
      shapeRendering="geometricPrecision"
      viewBox="112.26386806596702 29.759999999999998 418.35082458770614 416.64"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      id="eJ0hkPiw5uN1"
      width="28"
      height="28"
    >
      <style>
        {`
          #eJ0hkPiw5uN2_ts {animation: eJ0hkPiw5uN2_ts__ts 1000ms linear 1 normal forwards}
          @keyframes eJ0hkPiw5uN2_ts__ts { 0% {transform: translate(320px,240px) scale(0,0);animation-timing-function: cubic-bezier(0.9,0,0.1,1)} 41.658342% {transform: translate(320px,240px) scale(1.07,1.07)} 100% {transform: translate(320px,240px) scale(1.07,1.07)}} 
          #eJ0hkPiw5uN3 {animation: eJ0hkPiw5uN3_s_w 1000ms linear 1 normal forwards}
          @keyframes eJ0hkPiw5uN3_s_w { 0% {stroke-width: 366;animation-timing-function: cubic-bezier(0.9,0,0.1,1)} 41.658342% {stroke-width: 0} 100% {stroke-width: 0}}
          #eJ0hkPiw5uN4_ts {animation: eJ0hkPiw5uN4_ts__ts 1000ms linear 1 normal forwards}
          @keyframes eJ0hkPiw5uN4_ts__ts { 0% {transform: translate(320px,240px) scale(0,0);animation-timing-function: cubic-bezier(0.6,0,0,1)} 38.311688% {transform: translate(320px,240px) scale(1,1)} 100% {transform: translate(320px,240px) scale(1,1)}} 
          #eJ0hkPiw5uN6_ts {animation: eJ0hkPiw5uN6_ts__ts 1000ms linear 1 normal forwards}
          @keyframes eJ0hkPiw5uN6_ts__ts {
            0% {transform: translate(319.97px,239.173px) scale(0,0)} 11.688312% {transform: translate(319.97px,239.173px) scale(0,0);
            animation-timing-function: cubic-bezier(0.6,0,0,1)} 50% {transform: translate(319.97px,239.173px) scale(1,1)} 100% {transform: translate(319.97px,239.173px) scale(1,1)}
          } 
          #eJ0hkPiw5uN6 {animation: eJ0hkPiw5uN6_c_o 1000ms linear 1 normal forwards}
          @keyframes eJ0hkPiw5uN6_c_o {
            0% {opacity: 0} 11.188811% {opacity: 0;animation-timing-function: step-end} 11.688312% {opacity: 1;animation-timing-function: step-end} 100% {opacity: 1}
          }
        `}
      </style>
      <defs>
        <linearGradient
          gradientTransform="translate(0 0)"
          gradientUnits="objectBoundingBox"
          spreadMethod="pad"
          y2="1"
          x2="0.5"
          y1="0"
          x1="0.5"
          id="eJ0hkPiw5uN8-fill"
        >
          <stop stopColor="rgba(255,255,255,0)" offset="0%" id="eJ0hkPiw5uN8-fill-0" />
          <stop stopColor="#010022" offset="100%" id="eJ0hkPiw5uN8-fill-1" />
        </linearGradient>
      </defs>
      <g transform="translate(320,240) scale(0,0)" id="eJ0hkPiw5uN2_ts">
        <g transform="translate(0,0)">
          <path
            strokeWidth="366"
            stroke={color}
            fillRule="evenodd"
            fill="none"
            paintOrder="stroke fill markers"
            d="M0,-186c-102.725,0-186,83.275-186,186s83.275,186,186,186s186-83.275,186-186-83.275-186-186-186Z"
            id="eJ0hkPiw5uN3"
          />
        </g>
      </g>
      <g transform="translate(320,240) scale(0,0)" id="eJ0hkPiw5uN4_ts">
        <g transform="translate(0,0)">
          <path
            strokeWidth="0"
            fill={color}
            d="M169.805,0.005c0,93.78-76.03,169.8-169.81,169.8s-169.8-76.02-169.8-169.8c0-93.79,76.02-169.81,169.8-169.81s169.81,76.02,169.81,169.81Z"
          />
        </g>
      </g>
      <g transform="translate(319.97,239.173) scale(0,0)" id="eJ0hkPiw5uN6_ts">
        <g id="eJ0hkPiw5uN6" transform="translate(0,0)" opacity="0">
          <path
            d="M-25.496,82.439c-.046,0-.091,0-.137-.001-4.077-.041-7.918-1.916-10.459-5.104c0,0-61.985-77.786-61.985-77.786-4.663-5.852-3.7-14.376,2.152-19.039s14.376-3.7,19.039,2.151c0,0,51.606,64.762,51.606,64.762s102.393-123.313,102.393-123.313c4.78-5.757,13.322-6.548,19.079-1.768c5.756,4.78,6.548,13.322,1.768,19.078c0,0-113.033,136.127-113.033,136.127-2.575,3.101-6.396,4.893-10.423,4.893Z"
            fill="#fff"
            strokeWidth="0"
          />
        </g>
      </g>
    </svg>
  );
};

export default TickAnimation;